import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { ModalModule } from 'ngx-bootstrap/modal';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ResComponentsCoreModule } from '@corteva-research/ngx-components-core';
import { ResComponentsCompatibilityModule } from '@corteva-research/ngx-components-compat';
import { ResearchAuthModule, ResearchAuthGuard } from 'research.oidc.angular';
import { SettingsModule } from 'research.web.settings';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { LoginModalComponent } from './login/login-modal.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { CookieModule } from 'ngx-cookie';
import { InternalServerErrorInterceptor, UnprocessableEntityInterceptor, ForbiddenErrorInterceptor } from './http/interceptors';
import { RequestCreationModule } from './request-creation/request-creation.module';
import { SharedModule } from './shared/shared.module';
import { AlertService } from './shared/services/alert.service';
import { ViewRequestModule } from './view-request/view-request.module';
import './rxjs-operators';
import { HelpModule } from './help/help.module';
import { ReportingModule } from './reporting/reporting.module';

ResearchAuthGuard.loginRoute = '/login';
const routes: Routes = [
  { path: 'home', component: HomeComponent, canActivate: [ResearchAuthGuard] },
  { path: 'login', component: LoginComponent },
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: '**', redirectTo: '/login', pathMatch: 'full' },
];


@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    LoginComponent,
    LoginModalComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    SettingsModule,
    BrowserAnimationsModule,
    RequestCreationModule,
    HelpModule,
    SharedModule,
    ViewRequestModule,
    ReportingModule,
    RouterModule.forRoot(routes),
    ModalModule.forRoot(),
    CookieModule.forRoot(),
    ResComponentsCoreModule.forRoot(),
    ResComponentsCompatibilityModule.forRoot(),
    ResearchAuthModule.withInterceptors([...ResearchAuthModule.defaultInterceptors(), 
      {
        provide: HTTP_INTERCEPTORS,
        useFactory: (alertService: AlertService) => new InternalServerErrorInterceptor(alertService),
        deps: [AlertService],
        multi: true
      },
      {
        provide: HTTP_INTERCEPTORS,
        useFactory: (alertService: AlertService) => new UnprocessableEntityInterceptor(alertService),
        deps: [AlertService],
        multi: true
      },
      {
        provide: HTTP_INTERCEPTORS,
        useFactory: (alertService: AlertService) => new ForbiddenErrorInterceptor(alertService),
        deps: [AlertService],
        multi: true
      }
    ])
  ],
  exports: [RouterModule],
  providers: [],
  bootstrap: [AppComponent]
})

export class AppModule { }



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/app.module.ts